<template>
  <div class="main-content orderImport">

    <updateBlackList v-if="editableRecord"
                     :drug="editableRecord"
                     type="autolist"
                     :closeModal="closeModal"
    />

    <div class="card" v-if="countries">
      <div class="card-body">
        <div class="flex">
          <div class="form-group m-r-10 mb-0">
            <label for="">Выберите страну</label>
            <select class="form-control" v-model="selectedCountry">
              <option v-for="(name, index) in countries" :value="index">{{ name }}</option>
            </select>
          </div>
          <!--          <div class="form-group m-r-10 mb-0">-->
          <!--            <label for="">Склад снабжения</label>-->
          <!--            <select class="form-control" v-model="supplyStoreId">-->
          <!--              <option v-for="(store, index) in [$AllStores[2], $AllStores[3]]" :value="store.id">{{ store.title }}</option>-->
          <!--            </select>-->
          <!--          </div>-->
          <div class="flex">
            <vue-ladda @click="getDrugs" button-class="btn btn-info align-self-end"
                       data-style="zoom-in"
                       :loading="btnLoading">Просчитать список
            </vue-ladda>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">

        <div class="text-center">
          <pulse-loader :loading="loading" :color="color"/>
        </div>

        <div v-if="drugs">
          <div class="text-right">
            <button @click="printTable" class="btn btn-success">Печать</button>
          </div>
          <div id="printTable">
            <table class="table table-sm table-hover default_table table-striped mt-0">
              <thead>
              <tr>
                <th width="50"></th>
                <th width="50"></th>
                <th>Препарат</th>
                <th width="150">
                  Общий Запрос
                  <v-popover
                    v-if="statSettings"
                    class="display-inline"
                    popoverClass="work_shift_popover"
                    popoverInnerClass="popover_content"
                    trigger="hover"
                    :auto-hide="true">
                    <div class="popover_icon">
                      <i class="icon-fa icon-fa-info"></i>
                    </div>
                    <template slot="popover">
                      <p class="mb-1">Статистика за: {{ statSettings.statistic_days }} дней</p>
                      <p class="mb-1">Запас на: {{ statSettings.storage_days }} дней</p>
                    </template>
                  </v-popover>
                </th>
                <th width="50" class="hide_print"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(drug, index) in activeDrugs" :class="selectedCountry != drug.income_country_id ? 'bg-danger' : ''">
                <td>{{ index + 1 }}</td>
                <td>
                  <span v-if="drug.cool" class="icon icon-snowflake"></span>
                </td>
                <td>{{ drug.title }} ({{ drug.id }})
                  <p class="pack_comment" v-if="drug.pack_set && drug.pack_set != 1">Препарат комплектный: <span class="badge badge-info">1 комплект</span> - <strong>{{ drug.pack_set }}</strong>
                    (зав.уп.)</p>
                  <p class="pack_comment" v-if="drug.pack_comment">{{ drug.pack_comment }}</p>
                  <p class="pack_box_comment" v-if="drug.pack_box_comment">{{ drug.pack_box_comment }}</p>
                </td>
                <td>
                  {{ getTotalAmount(drug.id) }}
                <td>
                  <dropdown-menu
                    v-model="drug.showDropDown"
                    :interactive="true"
                    :closeOnClickOutside="true"
                  >
                    <button class="btn btn-default dropdown-toggle1"><i class="icon-fa icon-fa-ellipsis-v"></i></button>
                    <div slot="dropdown">
                      <a @click="editRecord(drug)" class="dropdown-item pointer">Игнорирование</a>
                    </div>
                  </dropdown-menu>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="ignoredDrugs && Object.keys(ignoredDrugs).length">
      <div class="card-header"><h6>Препараты, которые игнорированны для просчета</h6></div>
      <div class="card-body">
        <table class="table table-sm table-hover table-striped">
          <thead>
          <tr>
            <th></th>
            <th>Препарат</th>
            <th>Запрос</th>
            <th class="hide_print">Комментарий</th>
            <th>Актуально до</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(drug, drugId, index) in ignoredDrugs">
            <td>{{ index + 1 }}</td>
            <td>
              {{ drug.title }} ({{ drugId }})
              <p class="pack_comment" v-if="drug.pack_comment">{{ drug.pack_comment }}</p>
              <p class="pack_box_comment" v-if="drug.pack_box_comment">{{ drug.pack_box_comment }}</p>
            </td>
            <td>
              {{ getTotalAmount(drugId) }}
            </td>
            <td class="hide_print">
              <div v-for="comment in drug.comments">
                <p class="mb-1">{{ comment.comment }}</p>
                <small>{{ comment.user_name }} ({{ comment.date }})</small>
              </div>
            </td>
            <td>
              {{ moment(drug.actual_date, 'DD.MM.YYYY') }}
            </td>
            <td>
              <dropdown-menu
                v-model="drug.showDropDown"
                :interactive="true"
                :closeOnClickOutside="true"
              >
                <button class="btn btn-default dropdown-toggle1"><i class="icon-fa icon-fa-ellipsis-v"></i></button>
                <div slot="dropdown">
                  <a @click="deleteIgnore(drug.id)" class="dropdown-item pointer">Удалить с игнорирования</a>
                </div>
              </dropdown-menu>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<script>

import Vue from 'vue'
import api from '@/api'
import moment from 'moment';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import updateBlackList from "./componetns/updateBlackList";
import DropdownMenu from '@innologica/vue-dropdown-menu'

import VueHtmlToPaper from 'vue-html-to-paper';

Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    // 'https://unpkg.com/kidlat-css/css/kidlat.css',
    '/assets/css/print.css?id=3'
    // '<%= BASE_URL %>/'

  ]
});

export default {
  title: 'Автосписки (Заказ)',
  components: {
    PulseLoader,
    VueLadda,
    updateBlackList,
    DropdownMenu,
  },
  computed: {
    $AllStores() {
      return this.$store.getters['platform/stores'];
    },
  },
  data() {
    return {
      show: false,
      drugs: null,
      editableRecord: null,
      requestedDrugs: null,
      drugNames: null,
      storeNames: null,
      inStore: null,
      storeRequest: null,
      orderRequests: null,
      color: '#5BBFDE',
      loading: true,
      visibleStatistics: {},
      countries: null,
      selectedCountry: null,
      btnLoading: false,
      showAllStatistics: false,
      ignoredDrugs: {},
      supplyStoreId: 2,
      activeDrugs: [],
      statSettings: null,
    }
  },
  mounted() {
    this.getCities();
  },
  methods: {
    async deleteIgnore(recordId) {
      let {data} = await api.post('/blacklist/update', {
        id: recordId,
        is_active: false,
      });
      if (data.success) {
        this.ignoredDrugs = Object.keys(this.ignoredDrugs).reduce((acc, i) => {
          if (this.ignoredDrugs[i].id !== recordId) {
            acc[this.ignoredDrugs[i].object_id] = this.ignoredDrugs[i];
          }
          return acc;
        }, {});
        this.updateDrugList();
      } else {
        toastr['warning'](data.message, 'Ошибка!');
      }
    },
    getTotalAmount(drugId) {
      let text = (this.orderRequests[drugId] && this.orderRequests[drugId][this.supplyStoreId] || 0)
        + (this.storeRequest[drugId] && this.storeRequest[drugId][this.supplyStoreId] || 0)
      if (this.orderRequests[drugId] && this.orderRequests[drugId][this.supplyStoreId]) {
        text += ' (бронь: ' + this.orderRequests[drugId][this.supplyStoreId] + ')';
      }
      return text;
    },
    printTable() {
      this.$htmlToPaper('printTable');
    },
    async getCities() {
      let {data} = await api.index('/getCountries');
      this.countries = data.countries;
      this.selectedCountry = Object.keys(this.countries)[0]
      this.loading = false;
    },
    updateDrugList() {
      this.activeDrugs = this.drugs.reduce((acc, d) => {
        if (!this.ignoredDrugs[d.id]) {
          acc.push({...d, ignored: false, showDropDown: false});
        }
        return acc;
      }, []);
    },
    async getDrugs() {
      this.btnLoading = true;
      this.loading = true;
      this.drugs = null;
      this.ignoredDrugs = [];
      this.requestedDrugs = null;
      let {data} = await api.post('/drugs/getDrugsForOrder2', {
        countryId: this.selectedCountry,
        supplyStoreId: this.supplyStoreId
      });

      this.storeRequest = data.drugsData.storeRequest;
      this.orderRequests = data.drugsData.reserveRequest;
      this.drugs = data.drugs;
      this.ignoredDrugs = data.drugs.reduce((acc, d) => {
        if (data.ignoredDrugs[d.id]) {
          acc[d.id] = {...d, ...data.ignoredDrugs[d.id], showDropDown: false}
        }
        return acc;
      }, {});
      this.statSettings = data.drugsData.settings;
      this.loading = false;
      this.btnLoading = false;

      this.updateDrugList();
    },
    moment: function (date, format) {
      if (!date) return;
      return moment(date).format(format);
    },
    closeModal(update = false) {
      if (update) {
        this.ignoredDrugs[update.id] = {...update, ...update.black_list, showDropDown: false};
        this.updateDrugList();
      }
      this.editableRecord = null;
    },
    editRecord(drug) {
      this.editableRecord = drug;
    },
  }

}

</script>

<style scoped>
.btn i {
  text-align: center;
}

.pack_comment,
.pack_box_comment {
  font-size: 11px;
  margin-bottom: 2px;
}

.pack_comment {
  color: #02026d;
}

.pack_box_comment {
  color: #0d6d02;
}

.icon-snowflake {
  display: inline-block;
  width: 15px;
  height: 17px;
  background: #5bbfde;
  margin: -3px 4px;
}

.popover_icon {
  margin-top: 2px;
  background-color: #5BBFDE;
  padding: 0px 7px;
  border-radius: 50%;
  color: white;
  cursor: pointer;
}

.display-inline {
  display: inline;
}
</style>

<style>
.orderImport .dropdown-menu a {
  color: #212529;
  text-decoration: none;
}

.orderImport .dropdown-menu {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, .15);
  right: 11px;
  left: auto;
}

.info_table th,
.info_table td {
  padding: 2px;
  text-align: center;
}

</style>
